import { Grid, Typography, WithStyles } from "@material-ui/core";
import * as React from "react";

import { ProductAAHelper } from "../../helper/ProductAA.helper";
import { Customer } from "../../types/Customer";
import { Form } from "../../types/Form";
import { ProductAA, productAASamplingIntervals } from "../../types/ProductAA";
import { Products } from "../../types/Products";
import { Quotation } from "../../types/Quotation";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import Contribution from "../Contribution/Contribution";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import InputRadio from "../InputRadio/InputRadio";
import InputSelect from "../InputSelect/InputSelect.component";
import { Warning } from "../Warning/Warning";
import { quotationFormStyles } from "./QuotationForm.styles";

interface QuotationProductAAProps extends WithStyles<typeof quotationFormStyles> {
    mode?: "calculator";
    productHelper: ProductAAHelper;
    customer: Customer;
    quotation: Quotation;
    showError(message: string);
    hideError();
    onChange(product: Products);
}

type QuotationProductAAState = {
    form: Form<Products>;
};

class QuotationFormProductAA extends React.Component<QuotationProductAAProps, QuotationProductAAState> {
    private formBuilder = null;

    public async componentWillMount() {
        this.updateState(this.props);
    }

    public componentWillReceiveProps(nextProps: QuotationProductAAProps) {
        this.updateState(nextProps);
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
        this.props.onChange(form.values);
    }

    public render() {
        if (!this.state || !this.props.customer || !this.props.customer.birthdate) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);
        const product: ProductAA = this.props.quotation.product as ProductAA;

        return (
            <>
                {/* Mode de prélèvement */}

                <div className={this.props.classes.box}>
                    <Typography
                        variant={this.props.mode === "calculator" ? "headline" : "title"}
                        gutterBottom={true}
                        className={this.props.classes.formTitle}
                    >
                        {this.props.mode === "calculator" ? "Mode de prélèvement" : "4/ Mode de prélèvement"}
                    </Typography>
                    <Grid container={true} spacing={16}>
                        <Grid item={true}>
                            <InputRadio {...uiForm.fields.samplingInterval} />
                        </Grid>
                    </Grid>
                </div>

                {/* Garanties */}

                <div className={this.props.classes.box}>
                    <Typography
                        variant={this.props.mode === "calculator" ? "headline" : "title"}
                        gutterBottom={true}
                        className={this.props.classes.formTitle}
                    >
                        {this.props.mode === "calculator" ? "Garanties" : "5/ Garanties"}
                    </Typography>
                    <Grid container={true} spacing={16}>
                        <Grid item={true} sm={3} className={this.props.classes.guarantyBox}>
                            <InputCheckbox {...uiForm.fields.isGPAT} />
                            <div className={this.props.classes.guarantyBoxInput}>
                                <InputSelect {...uiForm.fields.GPATAnnuity} />
                            </div>
                        </Grid>
                        <Grid item={true} sm={3} className={this.props.classes.guarantyBoxOptional}>
                            <InputCheckbox {...uiForm.fields.isGPAP} />
                            <div className={this.props.classes.guarantyBoxInput}>
                                <InputSelect {...uiForm.fields.GPAPAnnuity} />
                            </div>
                        </Grid>
                        <Grid item={true} sm={3} className={this.props.classes.guarantyBoxOptional}>
                            <InputCheckbox {...uiForm.fields.isGCA} />
                            <div className={this.props.classes.guarantyBoxInput}>
                                <InputSelect {...uiForm.fields.GCACapital} />
                            </div>
                        </Grid>
                        <Grid item={true} sm={3} className={this.props.classes.guarantyBoxOptional}>
                            <InputCheckbox {...uiForm.fields.isGA} />
                        </Grid>
                    </Grid>
                </div>

                {/* Cotisations */}

                {product && product.contribution ? (
                    <div className={this.props.classes.box}>
                        <Typography
                            variant={this.props.mode === "calculator" ? "headline" : "title"}
                            gutterBottom={true}
                            className={this.props.classes.formTitle}
                        >
                            {this.props.mode === "calculator" ? "Cotisations" : "6/ Cotisations"}
                        </Typography>
                        <div className={this.props.classes.cotisationsBox}>
                            <Warning>
                                Votre adhésion est soumise à une déclaration d'état de santé. Vous devez faire parvenir
                                votre Déclaration d'Etat de Santé (et votre questionnaire médical si nécéssaire) au
                                médecin conseil dans l'enveloppe confidentielle prévue à cet effet.
                            </Warning>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxTitle}>
                                <b>
                                    Votre profil médical sera étudié par le médecin conseil d'AG2R LA MONDIALE. Celui-ci
                                    statuera sur :
                                </b>
                            </Typography>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxItem}>
                                L'acceptation de votre adhésion <u>sans surprime.</u>
                                <br />
                                Votre cotisation sera de &nbsp;
                                <Contribution
                                    value={this.props.productHelper.getPeriodicContribution()}
                                    interval={product.samplingInterval}
                                />
                                .
                            </Typography>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxItem}>
                                <u>L'application d'une surprime.</u>Vous recevrez alors une nouvelle proposition
                                d'adhésion à retourner signée dans l'enveloppe jointe.
                                <br />
                                Votre cotisation sera alors au maximum de &nbsp;
                                <Contribution
                                    value={this.props.productHelper.getPeriodicContributionMax()}
                                    interval={product.samplingInterval}
                                />
                                .
                            </Typography>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxItem}>
                                <u>Le refus.</u> Vous recevrez alors un courrier d’information. 
                                <br />
                            </Typography>
                        </div>
                        <div className={this.props.classes.cotisationsBoxResume}>
                            <Typography variant="display3" className={this.props.classes.cotisationsBoxResumeItem}>
                                <b>RÉSUMÉ</b>
                            </Typography>
                            <Typography variant="display3" className={this.props.classes.cotisationsBoxResumeItem}>
                                Votre cotisation sera de{" "}
                                <Contribution
                                    value={this.props.productHelper.getPeriodicContribution()}
                                    interval={product.samplingInterval}
                                />{" "}
                                en cas d’acceptation sans surprime.
                                <br />
                                Votre cotisation sera alors au maximum de{" "}
                                <Contribution
                                    value={this.props.productHelper.getPeriodicContributionMax()}
                                    interval={product.samplingInterval}
                                />{" "}
                                en cas d'acceptation avec surprime.
                            </Typography>
                        </div>
                    </div>
                ) : null}
            </>
        );
    }

    private updateState(props: QuotationProductAAProps) {
        const product = this.updateProduct(props);

        this.formBuilder = new UiFormBuilder<Products>();

        this.formBuilder

            // Mode de prélèvement

            .addField("samplingInterval", {
                props: {
                    items: productAASamplingIntervals,
                },
            })

            // GPAT

            .addField("isGPAT", {
                props: {
                    readonly: true,
                    label: "Garantie perte d'autonomie totale",
                },
            })
            .addField("GPATAnnuity", {
                props: {
                    label: "Rente mensuelle",
                    items: this.props.productHelper.getGPATAnnuityItems(),
                    required: true,
                    description: "€",
                },
            })

            // GPAP

            .addField("isGPAP", {
                props: {
                    label: "Garantie perte d'autonomie partielle",
                    disabled: !product.GPATContribution,
                },
            })
            .addField("GPAPAnnuity", {
                props: {
                    label: "Rente mensuelle",
                    items: this.props.productHelper.getGPAPAnnuityItemsSelect(),
                    disabled: true,
                    description: "€",
                },
            })

            // GCA

            .addField("isGCA", {
                props: {
                    label: "Garantie capital aménagement",
                    disabled: !product.GPATContribution && !product.GCAContribution,
                },
            })
            .addField("GCACapital", {
                props: {
                    label: "Montant du capital",
                    items: this.props.productHelper.getGCACapitalItems(),
                    disabled: !product.isGA,
                },
            })

            // GA

            .addField("isGA", {
                props: {
                    label: "Garantie assistance",
                    readonly: false,
                },
            })

            // Total

            .addField("monthlyContribution", {
                props: {
                    disabled: true,
                    label: "Montant mensuel",
                },
            })

            .onChange(this.onChange.bind(this));

        this.setState({
            form: {
                fields: {},
                errors: [],
                values: product,
            },
        });
    }

    private updateProduct(props) {
        let product = props.quotation.product as ProductAA;

        try {
            if (product.GPATAnnuity && props.customer.birthdate) {
                product.GPATContribution = this.props.productHelper.getGPATContribution();
                product.GPAPAnnuity = this.props.productHelper.getGPAPAnnuityItems();
            }

            if (product.GPAPAnnuity && props.customer.birthdate) {
                product.GPAPContribution = this.props.productHelper.getGPAPContribution();
            }

            if (product.GCACapital && props.customer.birthdate) {
                product.GCAContribution = this.props.productHelper.getGCAContribution();
            }

            if (product.GPATContribution) {
                product.contribution = this.props.productHelper.getContribution();
                product.contributionMax = this.props.productHelper.getContributionMax();
            }

            this.props.hideError();
        } catch (e) {
            this.props.showError(e.message);
        }

        return product;
    }
}

export default QuotationFormProductAA;



// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormProductAA.tsx